import React from 'react'
import { Link } from "gatsby"
import boxStyle from "../components/css/box.module.scss";

export default function({label, icon, instructor, slug, url}){
    icon = (icon == "Make a selection") ? false : icon;

    return(
        <div className={boxStyle.box}>
          {icon && <div className={boxStyle.icon}><img src={"http://api.vanarts.com/assets/"+icon}/></div>}
          <Link to={slug}>{label}
         { instructor && <span className={boxStyle.instructor}>{instructor}</span>}
          </Link>
      </div> 
    )
}